// CKEditor 5 commercial license key, set at runtime from the application Layout.
// The value is read from Web.config appSettings["CKEditorLicenseKey"] which is
// substituted by Octopus Deploy per environment.
//
// The key is stored on window rather than in module state because pages load multiple
// webpack bundles, each with its own instance of this module: the bundle containing
// buildContext/portalApp sets the key, while editors in other bundles (e.g. the
// address book contact editor) read it. Module-local state would leave those readers
// with an empty key and crash editors with license-key-missing.
const windowKey = "__matrixCkEditorLicenseKey";

export function setCkEditorLicenseKey(key: string) {
  (window as any)[windowKey] = key;
}

export function getCkEditorLicenseKey(): string {
  return (window as any)[windowKey] || "";
}
